var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-day-count"},_vm._l((_vm.typeList),function(t){return _c('a-space',{key:t.key},[_c('span',[_vm._v(_vm._s(t.title))]),_c('a-radio-group',{attrs:{"value":t.min,"options":_vm.countOptions,"default-value":0.5},on:{"change":function($event){return _vm.handleCountChange($event, t)}}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }